/** Single-tenant helpers for IITH (and similar one-clinic deployments). */
export const SINGLE_TENANT =
  String(process.env.REACT_APP_SINGLE_TENANT || '').toLowerCase() === 'true'
  || String(process.env.REACT_APP_SINGLE_TENANT || '') === '1';

export const DEFAULT_TENANT_SLUG = (
  process.env.REACT_APP_DEFAULT_TENANT_SLUG || 'iit-hyderabad'
).toLowerCase();
